import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { OverlayLayoutComponent } from "@m19-board/overlay/overlay-layout/overlay-layout.component";
import { OverlayRule } from "@m19-board/overlay/overlay-service/overlay-rules";
import { RenewAdvertisingAccessButtonComponent } from "@m19-board/shared/renew-advertising-access-button/renew-advertising-access-button.component";

@Component({
  selector: "app-advertising-api-access-lost-overlay",
  imports: [TranslocoDirective, OverlayLayoutComponent, RenewAdvertisingAccessButtonComponent],
  template: `
    <app-overlay-layout
      *transloco="let t"
      variant="warning"
      icon="alertCircle"
      [title]="t('overlays.advertising_api_access_lost_title')"
    >
      <p overlayBody>{{ t("overlays.advertising_api_access_lost_reason") }}</p>
      <p overlayBody>{{ t("overlays.advertising_api_access_lost_action") }}</p>
      <app-renew-advertising-access-button overlayCta [label]="t('overlays.advertising_api_access_lost_cta')" />
    </app-overlay-layout>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdvertisingApiAccessLostOverlayComponent {
  static readonly rule = OverlayRule.ADVERTISING_API_ACCESS_LOST;
}
